export const ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/gif']
